<ng-container *ngIf="(viewData$ | async) && (view$ | async) as view">
	<ntap-dynamic #dynamic *ngFor="let action of view.actions" [compId]="getActionComponentId(action)"
		[inputParam]="action" hidden='true'>
	</ntap-dynamic>
		<ng-container *ngIf="filteredItemsWithoutFirst$ | async as items">
			<ng-container *ngIf="filteredFirstAction$ | async as firstAction">
				<ng-container *ngIf="!!view.actions && items.length < 1">
						<p-button   [icon]="'pi ' + ($any(firstAction).icon ? 'pi-' + $any(firstAction).icon : 'pi-hidden')"
        					[ngClass]="$any(firstAction).name + ' hide-label-responsive'" ntapDebounceClick [label]="firstAction.label" (onClick)="firstAction.command($event)" [pTooltip]="$any(firstAction).tooltip" [disabled]="$any(firstAction).disabled" tooltipPosition="left"></p-button>
				</ng-container>
				<ng-container *ngIf="!!view.actions && items.length >= 1">
						<p-splitButton [icon]="'pi ' + ($any(firstAction).icon ? 'pi-' + $any(firstAction).icon : 'pi-hidden')"
        				     ntapDebounceClick [label]="firstAction.label"
							(onClick)="!$any(firstAction).disabled && firstAction.command($event)" [model]="items" class="hide-label-responsive" [ngClass]="{ 'disable-first': $any(firstAction).disabled }" 
							[pTooltip]="$any(firstAction).tooltip" tooltipPosition="left" appendTo="body">
						</p-splitButton>
				</ng-container>
		</ng-container>
	</ng-container> 
</ng-container>